<script>
    import { getContext } from "svelte";
    import { key as contentDresonRuleCtxKey } from "../context/contentDresonRule";

    /**
 *
 *
 *
 *
 */

    /*                */
    let { benefitDiscountValuePercent, benefitId = null, newSheetComponentEnabled = false } = $props();
    const contentDresonRule = getContext(contentDresonRuleCtxKey);

    /*                                                                                                           */
    const benefitBadgeUrl = `/benefit-sheet/sheet/reco/${benefitId}${contentDresonRule ? `?contextDreson=${contentDresonRule}${newSheetComponentEnabled ? "&useOcSheet=true" : ""}` : newSheetComponentEnabled ? "?useOcSheet=true" : ""}`;
</script>

{#if newSheetComponentEnabled}
    <oc-tag-v1
        data-oc-sheet-v1-create
        data-oc-sheet-v1-create.base64-url={btoa(benefitBadgeUrl)}
        class="reco_cinema__customer-benefit-badge reco_cinema__label-visibility oc-mt-25"
        size="50"
        variant="sale"
        show-info-icon
        >{benefitDiscountValuePercent}
    </oc-tag-v1>
{:else}
    <oc-tag-v1
        size="50"
        variant="sale"
        show-info-icon
        class="reco_cinema__customer-benefit-badge reco_cinema__label-visibility oc-mt-25 js_openInPaliSheet"
        data-sheet-url={benefitBadgeUrl}
        data-sheet-lock-mobile-height="false"
    >
        {benefitDiscountValuePercent}
    </oc-tag-v1>
{/if}

<style>
    .reco_cinema__label-visibility {
        z-index: 1;
    }
</style>
